export default __webpack_public_path__ + "static/media/10_gallery.7985f372.jpg";